export default __webpack_public_path__ + "static/media/BebasNeue.12e3683f.ttf";